// Tracks the in-flight canvas drag by element tuuid from beginDrag.
// react-dnd can set isAnyDragActive before isDragging on the source, and
// moveElement rewrites the path during hover — tuuid stays stable so the
// purple drag bar can mark the live drop slot.

let activeDragTuuid = null

export function setActiveDragTuuid(tuuid) {
    activeDragTuuid = tuuid || null
}

export function isActiveDragTuuid(tuuid) {
    return !!tuuid && activeDragTuuid === tuuid
}
